import { call, put, takeLatest, select } from 'redux-saga/effects';
import invokeApi from '../network';
import networkConfig from '../network/config';
import { getCustomerInfo } from '../redux/Actions/OrderservAction';
import { setErrorCode } from '../redux/Actions/ErrorAction';
import { OFFER_AND_DEALS_SUCCESS, OFFER_AND_DEALS_ERROR, OFFER_AND_DEALS_ACTION, GET_PAST_ORDERS, SAVE_PAST_ORDERS_REDUCER, ADD_NEW_ADDRESS, DELETE_SAVED_ADDRESS, } from '../constants';
export function* OfferAndDealsCall(data) {
    try {
        const { payload } = data;
        let config = null;
        switch (payload.userParams.disposition) {
            case 'pickup':
                config =
                    payload.userParams.mode === 'Web'
                        ? networkConfig.couponsDealsWeb.localizedPickup
                        : networkConfig.couponsDeals.localizedPickup;
                break;
            case 'delivery':
                config =
                    payload.userParams.mode === 'Web'
                        ? networkConfig.couponsDealsWeb.localizedDelivery
                        : networkConfig.couponsDeals.localizedDelivery;
                break;
            case 'dineIn':
                config =
                    payload.userParams.mode === 'Web'
                        ? networkConfig.couponsDealsWeb.localizedDineIn
                        : networkConfig.couponsDeals.localizedDineIn;
                break;
            default:
                config =
                    payload.userParams.mode === 'Web'
                        ? networkConfig.couponsDealsWeb.nonLocalized
                        : networkConfig.couponsDeals.nonLocalized;
                break;
        }
        const tenantReducer = yield select((state) => state.tenantReducer);
        const { response, status } = yield call(invokeApi, config, {
            queryProps: { tenantId: tenantReducer?.tenantId },
            disableHeaders: true,
        });
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: OFFER_AND_DEALS_SUCCESS,
                response,
            });
        }
        else {
            yield put({
                type: OFFER_AND_DEALS_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: OFFER_AND_DEALS_ERROR,
        });
    }
}
export function* OfferAndDealsSaga() {
    yield takeLatest(OFFER_AND_DEALS_ACTION, OfferAndDealsCall);
}
export function* fetchPastOrders(data) {
    const { payload } = data;
    const { response, status } = yield call(invokeApi, networkConfig.reOrderAndRecommendations, {
        queryProps: { customerId: payload?.customerId },
    }, {
        'x-tenant-id': payload?.tenantId,
        'x-user-id': payload?.customerId,
        'x-is-registered-user': true,
    });
    if (status >= 400) {
        yield put(setErrorCode(status));
    }
    if (response) {
        yield put({
            type: SAVE_PAST_ORDERS_REDUCER,
            response,
        });
    }
}
export function* reOrderSaga() {
    yield takeLatest(GET_PAST_ORDERS, fetchPastOrders);
}
export function* saveNewAddress(request) {
    const { payload, successCallback = null } = request;
    const response = yield call(invokeApi, networkConfig.addCustomerAddress, {
        queryProps: { customerId: payload?.customerId },
    }, {
        'x-tenant-id': payload.tenantId,
        'x-is-registered-user': true,
        'x-user-id': payload.customerId,
        'Content-Type': 'application/json',
    }, payload.data);
    if (response.status >= 400) {
        yield put(setErrorCode(response.status));
    }
    successCallback?.(response);
    const reqPayload = {
        updateUserData: true
    };
    yield put(getCustomerInfo(reqPayload));
}
export function* addNewAddressSaga() {
    yield takeLatest(ADD_NEW_ADDRESS, saveNewAddress);
}
export function* deleteAddress(request) {
    const { payload, successCallback = null } = request;
    const response = yield call(invokeApi, networkConfig.removeAddress, {
        queryProps: {
            customerId: payload?.customerId,
            addressId: payload?.addressId,
        },
    }, {
        'x-tenant-id': payload.tenantId,
        'x-is-registered-user': 'true',
        'x-user-id': payload.customerId,
        // "cache-control":"no-cache",
    });
    if (response.status >= 400) {
        yield put(setErrorCode(response.status));
    }
    successCallback?.(response);
    const reqPayload = {
        updateUserData: true
    };
    yield put(getCustomerInfo(reqPayload));
}
export function* deleteAddressSaga() {
    yield takeLatest(DELETE_SAVED_ADDRESS, deleteAddress);
}
